export const displayTemplateLabel = (
	templateCode: string,
	templateName?: string | null
) => {
	return templateName ? `${templateName} (${templateCode})` : templateCode;
};
